import { selectConfigValue } from '../../../shared/selectors/config';
import { getIsCommercial } from '../../../shared/utils/category/getIsCommercial';

const AUCTION_SERVICE_MAP = {
  top3: 'top3',
  premium: 'premium',
  'premium+highlight': 'premium',
  paid: 'paid',
  free: 'free',
};

export default [
  '$http',
  'addFormService',
  'addressService',
  '$q',
  'placingTermsApi',
  'store',
  function ($http, addFormService, addressService, $q, placingTermsApi, store) {
    const state = store.getState();
    const auctionBrowserUrl = selectConfigValue('auctionBrowserUrl', state);

    const prepareAuctionData = () => {
      const { bargainTerms, category, id: offerId, totalArea, areaParts } = addFormService.ad;
      const geo = addressService.geoObject;
      const { selected } = placingTermsApi;
      const optionId = selected && selected.option && selected.option.id;

      const params = {
        offerId,
        category,
        geoId: geo && geo.geoId,
        geoType: geo && geo.geoType,
        price: bargainTerms && bargainTerms.price,
        service: AUCTION_SERVICE_MAP[optionId],
      };

      const isCommercial = !!category && getIsCommercial(category);

      if (isCommercial) {
        Object.assign(params, {
          currency: bargainTerms && bargainTerms.currency,
          priceType: bargainTerms && bargainTerms.priceType,
          paymentPeriod: bargainTerms && bargainTerms.paymentPeriod,
          totalArea,
          multiListingSlotsCount: areaParts?.length ?? null,
        });
      }

      return params;
    };

    const isRequiredParamsAssigned = params => {
      return params.every(param => typeof param !== 'undefined' && param !== null);
    };

    const getTopBetsByAnnouncement = (concurrencyType = 'local', topCount = 5) => {
      const {
        offerId,
        category,
        geoId,
        geoType,
        price,
        service,
        currency,
        priceType,
        paymentPeriod,
        totalArea,
        multiListingSlotsCount,
      } = prepareAuctionData();

      if (!isRequiredParamsAssigned([category, geoId, geoType, price, service])) {
        return $q.reject();
      }

      const query = [
        offerId ? `announcementId=${offerId}` : '',
        category ? `category=${category}` : '',
        geoId ? `geoId=${geoId}` : '',
        geoType ? `geoType=${geoType}` : '',
        price ? `price=${price}` : '',
        concurrencyType ? `concurrencyType=${concurrencyType}` : '',
        topCount ? `topCount=${topCount}` : '',
        service ? `service=${service}` : '',
        currency ? `currency=${currency}` : '',
        priceType ? `priceType=${priceType}` : '',
        paymentPeriod ? `paymentPeriod=${paymentPeriod}` : '',
        totalArea ? `totalArea=${totalArea}` : '',
        multiListingSlotsCount ? `multiListingSlotsCount=${multiListingSlotsCount}` : '',
      ]
        .filter(Boolean)
        .join('&');

      return $http.get(auctionBrowserUrl + `/v2/get-top-bets-by-announcement/?${query}`);
    };

    const getBetPositionForecast = (bet, concurrencyType = 'local') => {
      const {
        offerId,
        category,
        geoId,
        geoType,
        price,
        service,
        currency,
        priceType,
        paymentPeriod,
        totalArea,
        multiListingSlotsCount,
      } = prepareAuctionData();

      if (!isRequiredParamsAssigned([category, geoId, geoType, price, service])) {
        return $q.reject();
      }

      const query = [
        offerId ? `announcementId=${offerId}` : '',
        `bet=${bet || 0}`,
        category ? `category=${category}` : '',
        geoId ? `geoId=${geoId}` : '',
        geoType ? `geoType=${geoType}` : '',
        price ? `price=${price}` : '',
        concurrencyType ? `concurrencyType=${concurrencyType}` : '',
        service ? `service=${service}` : '',
        currency ? `currency=${currency}` : '',
        priceType ? `priceType=${priceType}` : '',
        paymentPeriod ? `paymentPeriod=${paymentPeriod}` : '',
        totalArea ? `totalArea=${totalArea}` : '',
        multiListingSlotsCount ? `multiListingSlotsCount=${multiListingSlotsCount}` : '',
      ]
        .filter(Boolean)
        .join('&');

      return $http.get(auctionBrowserUrl + `/v2/get-increase-bets-positions-count-by-announcement/?${query}`, {
        withCredentials: true,
      });
    };

    const getAuctionBetInfo = () => {
      return $http.get(auctionBrowserUrl + '/v1/get-bet-info/', { withCredentials: true });
    };

    return {
      getTopBetsByAnnouncement,
      getBetPositionForecast,
      getAuctionBetInfo,
    };
  },
];
